import {useCallback, useMemo} from 'react';

import {observer} from 'mobx-react-lite';

import type {GetComponentProps} from '../../utils/utility-types';
import type {Props} from './types';

import {ListItem} from './ListItem';
import {IFileModel} from './model';

export const FilesListItem = observer<Props>(
  ({
    file,
    iconVariant,
    onDeleteButtonClick,
    onMoreButtonClick,
    sizeVariant,
    variant,
    ...rest
  }) => {
    const model = useMemo(() => new IFileModel(file), [file]);

    const onDeleteButtonClickCb: GetComponentProps<
      typeof ListItem
    >['onDeleteButtonClick'] = useCallback(
      e => {
        e.event.DOMEvent?.stopPropagation();

        onDeleteButtonClick?.(file);
      },
      [file, onDeleteButtonClick],
    );

    const onMoreButtonClickCb: GetComponentProps<
      typeof ListItem
    >['onMoreButtonClick'] = useCallback(
      e => {
        e.event.DOMEvent?.stopPropagation();
        onMoreButtonClick?.(e, file);
      },
      [file, onMoreButtonClick],
    );

    return (
      <ListItem
        accentColor={variant === 'coloured' ? model.accentColor : undefined}
        ext={model.ext}
        icon={model.icon}
        iconVariant={iconVariant}
        isImage={model.isImage}
        isUrl={model.isUrl}
        name={model.nameWoExt}
        onDeleteButtonClick={
          onDeleteButtonClick ? onDeleteButtonClickCb : undefined
        }
        onMoreButtonClick={onMoreButtonClick ? onMoreButtonClickCb : undefined}
        preview={model.preview}
        size={model.size}
        sizeVariant={sizeVariant}
        url={model.url}
        variant={variant}
        {...rest}
      />
    );
  },
);
